import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useToast from '../../hooks/useToast';

export default function CusUpload({
  id,
  title = 'Select file',
  accept,
  multiple,
  onChange,
  ref,
  maxSizeMB = 15
}) {
  const { t } = useTranslation();
  const { infoToast } = useToast();

  const handleChange = (e) => {
    const files = Array.from(e.target.files);
    const maxSize = maxSizeMB * 1024 * 1024;

    // Проверяем размер каждого файла
    const oversizedFile = files.find((file) => file.size > maxSize);

    if (oversizedFile) {
      infoToast(
        `${t('File')} "${oversizedFile.name}" ${t('exceeds the maximum size of')} ${maxSizeMB}MB`
      );

      e.target.value = ''; // Очищаем input
      return;
    }

    // Все файлы валидны
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <>
      <input
        accept={accept}
        style={{ display: 'none' }}
        id={id}
        ref={ref}
        multiple={multiple}
        type="file"
        onChange={handleChange}
      />
      <label htmlFor={id} style={{ marginTop: 'auto' }}>
        <Button variant="outlined" component="span">
          {t(title)}
        </Button>
      </label>
    </>
  );
}
